<template>
  <base-card :title="$t('menu.clinical_documents')">
    <!-- <div class="mb-2"><b-icon-file-earmark-text class="mr-2"></b-icon-file-earmark-text>{{ $t('menu.clinical_documents') }}</div> -->
    <paginated-table :fields="fields" :items="documentsTable.files" :loading="documentsTable.loading" :empty-text="$t('no-documents-found')">
      <template v-slot:cell(preview)="data">
        <img class="clickable" @click="buildLightboxItem(data.item.url)" src="/static-appopensalud/img/icons/morillas-svg-icons/primary-filled/eye.svg"/>
      </template>
    </paginated-table>
    <!-- <b-table :fields="fields" :items="$store.state.documentsTable.files" responsive :busy="$store.state.documentsTable.loading" sticky-header small show-empty :empty-text="$t('no-documents-found')">
      <template v-slot:table-busy>
        <loading-anim :active="$store.state.documentsTable.loading"></loading-anim>
      </template>
      <template v-slot:cell(preview)="data">
        <b-button class="d-flex" variant="primary" @click="buildLightboxItem(data.item.url)" size="sm"><b-icon-eye></b-icon-eye>{{$t('preview-file')}} </b-button>
      </template>
    </b-table> -->
    <!-- <div v-else>
      {{ $t('no-documents-found') }}
    </div> -->

    <div class="mt-4">
      <div class="mt-2 mb-2"><b-icon-upload class="mr-2"></b-icon-upload>{{ $t('upload-files') }}</div>
      <base-select v-model="uploaderSelectedType" v-if="documentsTable.uploader.fileTypes" :options="documentsTable.uploader.fileTypes" :label="`name.${$i18nHelpers.getNormalizedLocale()}`" valueProp="id" :placeholder="$t('select-file-type')" autoDropdownPlacement></base-select>
      <b-form-file class="mt-2"
      v-model="uploaderFile"
      :placeholder="$t('select-or-drag-drop-file')"
      :drop-placeholder="$t('drag-drop-file')"
      :browse-text="$t('browse')"
      @input="uploadFile"
      ></b-form-file>
    </div>
  </base-card>
</template>

<script>
import { BIconEye, FormFilePlugin, BIconUpload, BButton, BIconFileEarmarkText, BTable, BFormFile } from 'bootstrap-vue'
/* import { VueGoodTable } from 'vue-good-table' */
import 'vue-good-table/dist/vue-good-table.css'
import LoadingAnim from '@/components/utils/LoadingAnim.vue'
import PaginatedTable from '@/components/base/PaginatedTable.vue'
import BaseCard from '@/components/base/ui/BaseCard.vue'
import filters from '@/plugins/filters'
import { mapState } from 'vuex'

export default {
  components: {
    BIconEye,
    BIconUpload,
    FormFilePlugin,
    BButton,
    BIconFileEarmarkText,
    BTable,
    BFormFile,
    'loading-anim': LoadingAnim,
    'base-select': () => import('@/components/base/forms/BaseSelect.vue'),
    PaginatedTable,
    BaseCard
  },
  created () {
    this.$store.dispatch('video/loadDocumentsTable')
    this.loadFileTypes()
  },
	computed: {
		...mapState('video', ['documentsTable']),
		uploaderSelectedType: {
			get () {
				return this.documentsTable.uploader.selectedType
			},
			set (value) {
				this.$store.commit('video/setDocumentsTableUploaderSelectedType', value)
			}
		},
		uploaderFile: {
			get () {
				return this.documentsTable.uploader.file
			},
			set (value) {
				this.$store.commit('video/setDocumentsTableUploaderFile', value)
			}
		}
	},
  data () {
    return {
      loading: false,
      fields: [
				{
          label: '',
          key: 'preview'
        },
        {
          label: this.$t('file-name'),
          key: 'file.name',
          tdClass: `text-nowrap ${this.$uiHelpers.isMobile ? 'td-sm text-truncate' : ''}`
        },
        {
          label: this.$t('file-type'),
          key: `fileType.name.${this.$i18nHelpers.getNormalizedLocale()}`,
          thClass: this.$uiHelpers.isMobile ? 'd-none' : '',
          tdClass: this.$uiHelpers.isMobile ? 'd-none' : ''
        },
        {
          label: this.$t('date'),
          key: 'date',
          formatter: (value, key, item) => {
            return filters.beautifySimpleDate(value)
          }
        }
      ],
      lightbox: {
        items: [],
        index: null
      },
      loadFileTypes () {
        this.$api.get('FileTags').then((response) => {
          this.$store.commit('video/setDocumentsTableUploaderFileTypes', response.data)
        })
      }
    }
  },
  methods: {
    buildLightboxItem (src) {
      this.$store.commit('video/addToLightbox', src)
    },
    uploadFile (file) {
      this.$store.dispatch('video/uploadClinicalDocument', { file, fileTagId: this.uploaderSelectedType }).then((response) => {
				this.$store.dispatch('video/loadDocumentsTable')
				this.$store.dispatch('video/resetDocumentsTableUploader')
				this.$store.dispatch('video/sendSignalMessage', { msg: file.name })
				this.$store.dispatch('video/sendSignalFileMessage', response.data.data)
				this.$store.commit('video/showVideoSidebarAlert', {
          type: 'success',
          message: `${this.$t('uploaded-successfully')}`
        })
        this.$store.commit('video/setDocumentsTableLoading', false)
			})
    }
  }
}
</script>

<style>
  .td-sm {
    max-width: 60vw;
  }

  td>img {
    width: 1.5rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/video-launcher/DocumentsTable.vue